module.exports = __webpack_public_path__ + "static/media/tonies.7a7a5c72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tonies.jpg
// module id = 107
// module chunks = 0